import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pdf-app-loading" }
const _hoisted_2 = {
  id: "messagePdf",
  class: "txt-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderIcon = _resolveComponent("LoaderIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoaderIcon),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.message), 1)
  ]))
}